<panel>
  <select header [(ngModel)]="mode" (change)="synchronize()" *ngIf="mode == 'provider' || !displayingPartner" media="screen">
    <option value="customers">{{'Công nợ khách hàng' | lang}}</option>
    <option value="provider">{{'Công nợ với xưởng' | lang}}</option>
  </select>

  <select header [(ngModel)]="yearStamp" *ngIf="years && (!displayingPartner || displayingPartner.ID == 1)">
    <option *ngFor="let year of years" [ngValue]="year">{{year | date : 'yyyy'}}</option>
  </select>

  <div media="screen" header *ngIf="mode == 'customers' && displayingPartner" class="nowrap">
    <i class="fa fa-arrow-circle-left text-primary pointer std-margin-right" (click)="displaying.source = []; displayingPartner = null"></i>{{'Chi tiết công nợ khách hàng'}} <span class="text-primary">{{displayingPartner.Name}}</span> 
    <select header [(ngModel)]="yearStamp" *ngIf="years">
      <option *ngFor="let year of years" [ngValue]="year">{{year | date : 'yyyy'}}</option>
    </select>
  </div>

  <div header class="uppercase bold" media="print">{{(mode == 'customers' ? (!displayingPartner ? 'Danh sách công nợ khách hàng' : 'Chi tiết công nợ khách hàng') : 'Công nợ với xưởng') | lang}}{{ !displayingPartner ? ' (' + ('hiển thị' | lang) + ' ' + customers.matches.length + '/' + customers.source.length + ' ' + ('khách hàng' | lang) + ')' : ''}}{{displayingPartner && displayingPartner.ID != 1 ? ' ' + displayingPartner.Name : ''}}</div>

  <div right class="uppercase" media="print">{{now | date : 'dd-MM-yyyy HH:mm:ss z'}}</div>

  <div right class="flex" media="screen">

    <button class="text-white bg-warning" (click)="createExpense()" *ngIf="mode == 'provider'"><i class="fa fa-minus"></i></button>

    <ng-container *ngIf="mode == 'customers' && displayingPartner">
      <button class="text-white bg-warning std-margin-right" (click)="createDebt()"><i class="fa fa-pencil"></i></button>
      <button class="text-white bg-success std-margin-right" (click)="createIncome()"><i class="fa fa-minus"></i></button>
      <button class="text-white bg-danger" (click)="createExpense()"><i class="fa fa-plus"></i></button>
    </ng-container>

    <text-filter [target]="customers" [placeholder]="'Tìm khách hàng'" *ngIf="mode == 'customers' && !displayingPartner"></text-filter>
    <button class="bg-primary text-white pointer std-margin-left" (click)="print()"><i class="fa fa-print"></i></button>
    <button *ngIf="!displayingPartner" class="bg-success text-white pointer std-margin-left" (click)="exportExcel('all')"><i class="fa fa-file-excel"></i></button>
    <button *ngIf="displayingPartner" class="bg-success text-white pointer std-margin-left" (click)="exportExcel()"><i class="fa fa-file-excel"></i></button>
  </div>
  

  <table media="screen" class="data hover" responsive *ngIf="mode == 'customers' && !displayingPartner">
    <tr>
      <th class="text-right" style="width: 0">{{'STT' | lang}}</th>
      <th><sortable [target]="customers" [extractor]="extractor('name')">{{'Khách hàng' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="customers" [extractor]="extractor('id')">{{'Mã thanh toán' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('initial')">{{'Tồn đọng' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('raised')">{{'Phát sinh' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('returned')">{{'Đã thu' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('badLeft')" [selected]="true" [sort]="'descending'">{{'Cần thu' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('goodLeft')">{{'Cần trả' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of customers.pageMatches; index as ix" class="pointer" (click)="display(i.id)">
      <td><small>{{ix + 1 + customers.pageIndex * customers.pageSize}}</small></td>
      <td>
        <b>{{partner(i).Name}}</b>
        <br />
        <small>{{partner(i).Address}}</small>
      </td>
      <td class="spacy bold text-primary">K{{i.id}}</td>
      <td><b>{{i.initial | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{i.raised | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{i.returned | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{left(i,'bad') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{left(i,'good') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
    </tr>
    <tr *ngIf="customers.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="8" class="text-center"><pagination [target]="customers"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="customers.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{customers.matches.length}})</td>
      <td></td>
      <td><b [ngClass]="{'text-danger': sum('initial') > 0}">{{sum('initial') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{sum('raised') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{sum('returned') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{sum('badLeft') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{sum('goodLeft') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
    </tr>
  </table>

  <table media="print" class="data hover" responsive *ngIf="mode == 'customers' && !displayingPartner">
    <tr>
      <th class="text-right" style="width: 0">{{'STT' | lang}}</th>
      <th><sortable [target]="customers" [extractor]="extractor('name')">{{'Khách hàng' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="customers" [extractor]="extractor('id')">{{'Mã thanh toán' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('initial')">{{'Tồn đọng' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('raised')">{{'Phát sinh' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('returned')">{{'Đã thu' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('badLeft')" [selected]="true" [sort]="'descending'">{{'Cần thu' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="customers" [extractor]="extractor('goodLeft')">{{'Cần trả' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of customers.matches; index as ix" class="pointer" (click)="display(i.id)">
      <td><small>{{ix + 1}}</small></td>
      <td>
        <b>{{partner(i).Name}}</b>
        <br />
        <small>{{partner(i).Address}}</small>
      </td>
      <td class="spacy bold text-primary">K{{i.id}}</td>
      <td><b>{{i.initial | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{i.raised | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{i.returned | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{left(i,'bad') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{left(i,'good') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
    </tr>
    <tr class="footer" *ngIf="customers.source.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}}</td>
      <td></td>
      <td><b [ngClass]="{'text-danger': sum('initial') > 0}">{{sum('initial') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{sum('raised') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{sum('returned') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-danger">{{sum('badLeft') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
      <td><b class="text-success">{{sum('goodLeft') | number : '1.0-2' : 'en-US'}}</b><span class="hlf-margin-left opacity-75">đ</span></td>
    </tr>
  </table>
  

  <table media="screen" class="data hover" responsive *ngIf="displayingPartner">
    <tr>
      <th class="text-left nowrap">{{'Ngày' | lang}}</th>
      <th class="text-center">{{'Lý do' | lang}}</th>
      <th class="text-left">{{'Chứng từ' | lang}}</th>
      <th class="text-right">{{'Phát sinh nợ' | lang}}</th>
      <th class="text-right">{{'Phát sinh trả' | lang}}</th>
      <th class="text-right">{{'Công nợ còn lại' | lang}}</th>
    </tr>
    <tr *ngFor="let i of displaying.pageMatches" class="pointer" (click)="open(i)">
      <td class="bold">{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="uppercase nowrap small" [ngClass]="{'text-danger': raised(i) > 0, 'text-success': returned(i) > 0, 'text-warning': raised(i) < 0}">{{reason(i) | lang}}</td>
      <td>
        <div class="text-primary bold nowrap">{{related(i)}}</div>
        <span class="small uppercase" [ngClass]="{'text-success': i.Left == 0, 'text-warning': i.Left > 0}">{{status(i) | lang}}</span><span *ngIf="i.Left > 0" class="hlf-margin-left bold small"><number [good]="'none'" [sign]="false" [value]="i.Left * 100 / i.Total" [decimal]="1"></number>%</span>
      </td>
      <td><b [ngClass]="{'text-danger': raised(i) > 0, 'text-warning': raised(i) < 0}">{{raised(i) | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
      <td><b [ngClass]="{'text-success': returned(i) > 0}">{{returned(i) | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
      <td><b [ngClass]="{'text-success' : i.Turnover < 0, 'text-danger': i.Turnover > 0}">{{i.Turnover | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
    </tr>
    <tr *ngIf="displaying.pages.length > 1">
      <td [colSpan]="6" class="text-center" style="z-index: auto">
        <pagination [target]="displaying"></pagination>
      </td>
    </tr>
    <tr class="footer bold" *ngIf="displaying.source.length > 1">
      <td>{{'TỔNG' | lang}}</td>
      <td></td>
      <td></td>
      <td>
        <span class="text-danger">{{sum('raised') | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
      <td>
        <span class="text-success">{{sum('returned') | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
      <td>
        <span [ngClass]="{'text-success' : displaying.source[0].Turnover < 0, 'text-danger': displaying.source[0].Turnover > 0}">{{displaying.source[0].Turnover | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
    </tr>
  </table>

  <table media="print" class="data hover" responsive *ngIf="displayingPartner">
    <tr>
      <th class="text-left nowrap">{{'Ngày' | lang}}</th>
      <th class="text-center">{{'Lý do' | lang}}</th>
      <th class="text-left">{{'Chứng từ' | lang}}</th>
      <th class="text-right">{{'Phát sinh nợ' | lang}}</th>
      <th class="text-right">{{'Phát sinh trả' | lang}}</th>
      <th class="text-right">{{'Công nợ còn lại' | lang}}</th>
    </tr>
    <tr *ngFor="let i of displaying.source" class="pointer" (click)="open(i)">
      <td class="bold">{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="uppercase nowrap small" [ngClass]="{'text-danger': raised(i) > 0, 'text-success': returned(i) > 0, 'text-warning': raised(i) < 0}">{{reason(i) | lang}}</td>
      <td>
        <div class="text-primary bold nowrap">{{related(i)}}</div>
        <span class="small uppercase" [ngClass]="{'text-success': i.Left == 0, 'text-warning': i.Left > 0}">{{status(i) | lang}}</span><span *ngIf="i.Left > 0" class="hlf-margin-left bold small"><number [good]="'none'" [sign]="false" [value]="i.Left * 100 / i.Total" [decimal]="1"></number>%</span>
      </td>
      <td><b [ngClass]="{'text-danger': raised(i) > 0, 'text-warning': raised(i) < 0}">{{raised(i) | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
      <td><b [ngClass]="{'text-success': returned(i) > 0}">{{returned(i) | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
      <td><b [ngClass]="{'text-success' : i.Turnover < 0, 'text-danger': i.Turnover > 0}">{{i.Turnover | number : '1.1-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{i.Icon}}</span></td>
    </tr>
    <tr class="footer bold" *ngIf="displaying.source.length > 1">
      <td>{{'TỔNG' | lang}}</td>
      <td></td>
      <td></td>
      <td>
        <span class="text-danger">{{sum('raised') | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
      <td>
        <span class="text-success">{{sum('returned') | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
      <td>
        <span [ngClass]="{'text-success' : displaying.source[0].Turnover < 0, 'text-danger': displaying.source[0].Turnover > 0}">{{displaying.source[0].Turnover | number : '1.1-2' : 'en-US'}}</span>
        <vnd *ngIf="displayingPartner.ID != 1"></vnd>
        <cny *ngIf="displayingPartner.ID == 1"></cny>
      </td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
